import { createSlice } from '@reduxjs/toolkit';
import { fetchIcfData } from '../../api/ml';
const initialState = {
    data: null,
    error: null,
    loading: false,
    globalItemLists: []
};
export const icfSlice = createSlice({
    name: 'icf',
    initialState,
    reducers: {
        updateIcfSort: (state, action) => {
            state.data.ordered_design_list = action.payload;
        },
        updateGlobalArticles: (state, action) => {
            state.globalItemLists = action.payload;
        }
    },
    extraReducers: builder => {
        builder.addCase(fetchIcfData.pending, state => {
            state.loading = true;
        });
        builder.addCase(fetchIcfData.fulfilled, (state, action) => {
            state.data = action.payload;
            state.loading = false;
            state.error = null;
        });
        builder.addCase(fetchIcfData.rejected, (state, action) => {
            state.error = action.error;
            state.loading = false;
        });
    }
});
export const { updateIcfSort, updateGlobalArticles } = icfSlice.actions;
export const { reducer } = icfSlice;
//# sourceMappingURL=index.js.map